import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IrisFieldBaseComponent } from '@iris/common/modules/fields/field-base/field-base.component';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ChangeDetectionStrategy, forwardRef, Input, inject } from '@angular/core';

export enum ShareType {
  Private = 'PRIVATE',
  Specific = 'SPECIFIC',
  Public = 'PUBLIC',
}

export interface ShareTypeI {
  value: string;
  label: string;
}

export const SHARING_TYPES: ShareTypeI[] = [
  {
    value: ShareType.Private,
    label: 'label.Private',
  },
  {
    value: ShareType.Specific,
    label: 'label.Specific',
  },
  {
    value: ShareType.Public,
    label: 'label.Public',
  },
];

@Component({
  selector: 'iris-field-share-select',
  templateUrl: './field-share-select.component.html',
  styleUrls: ['./field-share-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IrisFieldShareSelectComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisFieldShareSelectComponent extends IrisFieldBaseComponent implements OnInit, ControlValueAccessor {
  private readonly translate = inject(TranslateService);

  readonly sharingTypes: ShareTypeI[] = SHARING_TYPES;

  @Input() privateTypeInfo = '';
  @Input() specificTypeInfo = '';

  get isSpecificSelected(): boolean {
    return this.valueControl.value === ShareType.Specific;
  }

  get selectedSharingTypeInfo(): string {
    if (this.valueControl.value === ShareType.Public) {
      return this.translate.instant('text.sharing.AvailableForAllUsers');
    }
    if (this.valueControl.value === ShareType.Private) {
      return this.privateTypeInfo;
    }
    return this.specificTypeInfo;
  }
}
